const chipDefaultStyle = theme => ({
  '&.MuiChip-root': {
    '&:active': {
      boxShadow: 'unset'
    },
    '&:focus-visible': {
      border: `1px solid ${theme.tokens.ComponentTextInputBorderFocusColor}`,
      boxShadow: theme.tokens.SemRingFocus
    }
  }
});
export default chipDefaultStyle;